module.exports = __webpack_public_path__ + "img/link_icon_5.ed50ec5.png";